<template>
    <v-container>
        <h3 class="grey--text text--darken-2">
            {{ getConfig('call_for_funds.labels.call_for_funds_title') }}
        </h3>

        <p
            class="subtitle-1 grey--text text--darken-2"
            v-html="getConfig('call_for_funds.labels.call_for_funds_intro')"
        ></p>

        <ProductsDisplayChips ref="productChip" :products="selectedSale.products" />
        <v-chip ref="programChip" color="app-green" class="ma-0 pa-1" small label dark>{{ selectedSale.program.title }}</v-chip>

        <v-row>
            <v-col v-if="!$vuetify.breakpoint.mobile" cols="12" lg="6">
                <ProgramSummary />
            </v-col>

            <v-col cols="12" lg="6">
                <v-card class="pt-4">
                    <v-card-title class="py-0">
                        <v-spacer />
                        <table>
                            <tbody>
                                <tr>
                                    <td class="font-weight-regular text-right pr-2 text-caption"> Votre acquisition </td>
                                    <td class="text-right" style="line-height: 0px;"> 
                                        <span class="font-weight-bold pl-2">
                                            <number
                                                :to="getSalePriceTTCWithoutTMA(selectedSale)"
                                                :format="$options.filters.toCurrencyString"
                                                :duration="1.5"
                                                easing="Power4.easeOut"
                                            />
                                        </span> 
                                    </td>
                                    <td style="line-height: 0px;">
                                        <v-tooltip max-width="450px" top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon class="pl-2" color="blue" v-on="on">fas fa-info-circle</v-icon>
                                            </template>
                                            L'affichage de vos appels de fonds et encaissements nécessite un délai de traitement de plusieurs jours car des actions manuelles par notre service comptabilité sont nécessaires pour permettre la mise à jour dans votre espace clients. <br>
                                            Chaque appel de fonds est envoyé en pièce jointe par mail en complément de votre espace clients. <br>
                                            Merci de votre compréhension.
                                        </v-tooltip>
                                    </td>
                                </tr>

                                <tr v-if="getSaleTotalTmaPriceTTC(selectedSale) > 0">
                                    <td class="font-weight-regular text-right pr-2 text-caption"> Montants TMA </td>
                                    <td class="text-right" style="line-height: 0px;"> 
                                        <span class="font-weight-bold pl-2">
                                            <number
                                                :to="getSaleTotalTmaPriceTTC(selectedSale)"
                                                :format="$options.filters.toCurrencyString"
                                                :duration="1.5"
                                                easing="Power4.easeOut"
                                            />
                                        </span> 
                                    </td>
                                </tr>

                                <tr v-if="getSaleTotalTmaPriceTTC(selectedSale) > 0">
                                    <td class="font-weight-regular text-right pr-2 text-caption"> Total </td>
                                    <td class="text-right" style="line-height: 0px;"> 
                                        <span class="font-weight-bold pl-2">
                                            <number
                                                :to="getSalePriceTTC(selectedSale)"
                                                :format="$options.filters.toCurrencyString"
                                                :duration="1.5"
                                                easing="Power4.easeOut"
                                            />
                                        </span> 
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <v-spacer />
                    </v-card-title>


                    <!-- <v-card-title class="py-0">
                        <v-spacer />
                        <h6 class="font-weight-regular mr-2">
                            Votre acquisition
                        </h6>
                        <span class="font-weight-bold">
                            <number
                                :to="getSalePriceTTCWithoutTMA(selectedSale)"
                                :format="$options.filters.toCurrencyString"
                                :duration="1.5"
                                easing="Power4.easeOut"
                            />
                        </span>
                        <v-spacer />
                    </v-card-title>

                    <v-card-title class="py-0">
                        <v-spacer />
                        <h6 class="font-weight-regular mr-2">
                            Montants TMA
                        </h6>
                        <span class="font-weight-bold">
                            <number
                                :to="getSaleTotalTmaPriceTTC(selectedSale)"
                                :format="$options.filters.toCurrencyString"
                                :duration="1.5"
                                easing="Power4.easeOut"
                            />
                        </span>
                        <v-spacer />
                    </v-card-title>

                    <v-card-title class="py-0">
                        <v-spacer />
                        <h6 class="font-weight-regular mr-2">
                            Total
                        </h6>
                        <span class="font-weight-bold">
                            <number
                                :to="getSalePriceTTC(selectedSale)"
                                :format="$options.filters.toCurrencyString"
                                :duration="1.5"
                                easing="Power4.easeOut"
                            />
                        </span>
                        <v-spacer />
                    </v-card-title> -->

                    <v-row class="mt-4" no-gutters>
                        <v-col class="text-center">
                            <v-progress-circular
                                rotate="-90"
                                :size="100"
                                :width="15"
                                :value="displayPercents ? totalCalledPercent : 0"
                                color="app-green"
                            >
                                <number
                                    :to="totalCalledPercent"
                                    :format="$options.filters.floor"
                                    :duration="1.5"
                                    easing="Power4.easeOut"
                                />
                                %
                            </v-progress-circular>
                            <br />

                            <span class="caption"> Montant appelé </span>
                            <br />

                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <span class="font-weight-bold" v-on="on">
                                        <number
                                            :to="getSaleTotalCalled(selectedSale)"
                                            :format="$options.filters.toCurrencyString"
                                            :duration="1.5"
                                            easing="Power4.easeOut"
                                        />
                                    </span>
                                </template>
                                Sur un total de
                                {{ getSalePriceTTC(selectedSale) | toCurrencyString() }}
                            </v-tooltip>
                        </v-col>

                        <v-col class="text-center">
                            <v-progress-circular
                                rotate="-90"
                                :size="100"
                                :width="15"
                                :value="displayPercents ? totalPaidPercent : 0"
                                color="app-red"
                            >
                                <number
                                    :to="totalPaidPercent"
                                    :format="$options.filters.floor"
                                    :duration="1.5"
                                    easing="Power4.easeOut"
                                />
                                %
                            </v-progress-circular>
                            <br />

                            <span class="caption"> Montant appelé réglé </span>
                            <br />

                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <span class="font-weight-bold" v-on="on">
                                        <number
                                            :to="totalPaid"
                                            :format="$options.filters.toCurrencyString"
                                            :duration="1.5"
                                            easing="Power4.easeOut"
                                        />
                                    </span>
                                </template>
                                Sur un total de
                                {{ getSaleTotalCalled(selectedSale) | toCurrencyString() }}
                            </v-tooltip>
                        </v-col>

                        <v-col class="text-center">
                            <v-progress-circular
                                rotate="-90"
                                :size="100"
                                :width="15"
                                :value="displayPercents ? 100 - $options.filters.floor(totalCalledPercent) : 0"
                                color="app-blue"
                            >
                                <number
                                    :to="100 - $options.filters.floor(totalCalledPercent)"
                                    :duration="1.5"
                                    easing="Power4.easeOut"
                                />
                                %
                            </v-progress-circular>
                            <br />

                            <span class="caption"> Reste à payer </span>
                            <br />

                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <span class="font-weight-bold" v-on="on">
                                        <number
                                            :to="getSalePriceTTC(selectedSale) - totalPaid"
                                            :format="$options.filters.toCurrencyString"
                                            :duration="1.5"
                                            easing="Power4.easeOut"
                                        />
                                    </span>
                                </template>
                                Sur un total de
                                {{ getSalePriceTTC(selectedSale) | toCurrencyString() }}
                            </v-tooltip>
                        </v-col>
                    </v-row>

                    <v-timeline>
                        <v-timeline-item
                            v-for="item of selectedSale.timetable2"
                            :key="item.id"
                            :color="getItemDotColor(item)"
                            :left="isItemLeft(item)"
                            :right="!isItemLeft(item)"
                            :icon="getItemDotIcon(item)"
                            fill-dot
                            :small="isItemDotSmall(item)"
                            :class="{ 'text-right': isItemLeft(item) }"
                        >
                            <template v-slot:opposite>
                                <template v-if="item.docs && item.docs.length === 1">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                :href="getDocumentUrl(item.docs[0].id)"
                                                target="_blank"
                                                icon
                                                v-on="on"
                                            >
                                                <v-icon color="red lighten-1">
                                                    mdi-file-pdf-box
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        Attestation d'avancement des travaux
                                    </v-tooltip>
                                </template>

                                <template v-if="item.docs && item.docs.length > 1">
                                    <v-menu offset-y max-height="300px">
                                        <template v-slot:activator="{ on }">
                                            <v-btn target="_blank" icon v-on="on">
                                                <v-icon color="red lighten-1">
                                                    mdi-file-pdf-box
                                                </v-icon>
                                            </v-btn>
                                        </template>

                                        <v-list>
                                            <v-list-item
                                                v-for="doc of item.docs"
                                                :key="doc.id"
                                                :href="getDocumentUrl(doc.id)"
                                                target="_blank"
                                                dense
                                            >
                                                <v-list-item-icon>
                                                    <v-icon color="red lighten-1">
                                                        mdi-file-pdf-box
                                                    </v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        {{ doc.title }}
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </template>
                            </template>

                            <template v-if="item.type === -1">
                                <span
                                    v-if="item.date"
                                    class="font-weight-bold grey--text text--darken-2"
                                >
                                    {{ item.date | toDate() }}
                                </span>

                                <br />

                                <span v-if="!!item.amount" class="font-weight-bold">
                                    {{ item.amount | toCurrencyWholeString() }},<small
                                        class="grey--text text--darken-2"
                                        >{{ item.amount | toCurrencyDecimalString() }}</small
                                    >
                                    €
                                </span>

                                <br />

                                <span class="subtitle-2 font-weight-light">
                                    {{ item.step }}
                                </span>
                            </template>

                            <template v-if="item.type === -2">
                                <span
                                    v-if="item.date"
                                    class="font-weight-bold grey--text text--darken-2"
                                >
                                    {{ item.date | toDate() }}
                                </span>

                                <br />

                                <v-chip class="ml-2 caption" color="app-blue" small label dark>
                                    {{ item.percent | toCurrencyWholeString() }},<small class="mr-1">{{
                                        item.percent | toCurrencyDecimalString()
                                    }}</small> %
                                </v-chip>

                                <br />

                                <span class="subtitle-2 font-weight-light">
                                    {{ item.step }}
                                </span>
                            </template>

                            <template v-if="item.type === 1">
                                <span
                                    v-if="item.date"
                                    class="font-weight-bold grey--text text--darken-2"
                                >
                                    {{ item.date | toDate() }}
                                </span>

                                <br />

                                <span class="font-weight-bold">
                                    {{ item.amount | toCurrencyWholeString() }},<small
                                        class="grey--text text--darken-2"
                                        >{{ item.amount | toCurrencyDecimalString() }}</small
                                    >
                                    €
                                </span>

                                <br />

                                <span class="subtitle-2 font-weight-light">
                                    {{ item.step }}
                                </span>
                            </template>

                            <template v-if="item.type === 2">
                                <span
                                    v-if="item.date"
                                    class="font-weight-bold grey--text text--darken-2"
                                >
                                    {{ item.date | toDate() }}
                                </span>

                                <br />

                                <span class="font-weight-bold">
                                    {{ item.amount | toCurrencyWholeString() }},<small
                                        class="grey--text text--darken-2"
                                        >{{ item.amount | toCurrencyDecimalString() }}</small
                                    >
                                    €
                                </span>

                                <br />

                                <span class="subtitle-2 font-weight-light">
                                    {{ item.step }}
                                </span>
                            </template>
                        </v-timeline-item>
                    </v-timeline>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { isBefore } from 'date-fns';

import salesMixin from '../../mixins/sales';
import documentsMixin from '../../mixins/documents';
import callForFundsMixin from '../../mixins/callForFunds';
import ProgramSummary from '../../components/program/ProgramSummary';
import ProductsDisplayChips from '../../components/dashboard/ProductsDisplayChips.vue';

export default {
    name: 'CallForFunds',

    mixins: [salesMixin, documentsMixin, callForFundsMixin],

    components: {
        ProgramSummary,
        ProductsDisplayChips
    },

    data: () => ({
        displayPercents: false
    }),

    methods: {
        getItemDotColor(item) {
            if ([1, 2].includes(item.type)) {
                return 'app-red';
            }
            if (item.type === -1) {
                return 'green';
            }

            return 'grey';
        },

        getItemDotIcon(item) {
            if (item.type === -1) {
                return 'mdi-send-outline';
            }

            if ([1, 2].includes(item.type)) {
                return 'mdi-send-outline mdi-rotate-180';
            }

            return '';
        },

        isItemDotSmall(item) {
            return item.type === -2;
        },

        isItemLeft(item) {
            return item.type < 0;
        },

        getTimeline() {
            let timeline = JSON.parse(JSON.stringify(this.selectedSale.timetable));
            let payments = JSON.parse(JSON.stringify(this.selectedSale.payments));
            let tmas = JSON.parse(JSON.stringify(this.selectedSale.tmas));

            for (let i = 0; i < timeline.length; i++) {
                const item = timeline[i];
                item.isLast = false;
                item.itemType = 'callForFunds';
                if (item.percent === 0 && item.fundcall && item.fundcall.amount > 0) {
                    const percent = item.fundcall.amount / this.getSalePriceTTC(this.selectedSale);
                    item.percent = percent * 100;

                    let sum = 0;
                    const steps = [item.step];
                    for (let j = i + 1; j < timeline.length; j++) {
                        timeline[j].hide = true;
                        steps.push(timeline[j].step);
                        sum += timeline[j].percent;
                        if (sum >= item.percent) {
                            break;
                        }
                    }
                    if (steps.length > 1) {
                        item.steps = steps;
                    }
                }
            }

            if (timeline.length > 0) {
                timeline[timeline.length - 1].isLast = true;
            }

            timeline = timeline.filter(t => !t.hide);

            for (const payment of payments) {
                const paymentDate = new Date(payment.date);
                let lastbefore = 0;
                for (let i = 0; i < timeline.length; i++) {
                    if (timeline[i].itemType === 'callForFunds') {
                        if (timeline[i].fundcall && timeline[i].fundcall.dateSent) {
                            const dateSent = new Date(timeline[i].fundcall.dateSent);
                            if (isBefore(paymentDate, dateSent)) {
                                payment.itemType = 'payment';
                                timeline.splice(lastbefore + 1, 0, payment);
                                break;
                            }
                            lastbefore = i;
                        }
                    } else {
                        lastbefore = i;
                    }
                }
                if (!payment.itemType) {
                    payment.itemType = 'payment';
                    timeline.splice(lastbefore + 1, 0, payment);
                }
            }

            for (const tma of tmas) {
                const tmaDate = new Date(tma.date);
                let lastbefore = 0;
                for (let i = 0; i < timeline.length; i++) {
                    if (timeline[i].itemType === 'callForFunds') {
                        if (timeline[i].fundcall && timeline[i].fundcall.dateSent) {
                            const dateSent = new Date(timeline[i].fundcall.dateSent);
                            if (isBefore(tmaDate, dateSent)) {
                                tma.itemType = 'tma';
                                timeline.splice(lastbefore + 1, 0, tma);
                                break;
                            }
                            lastbefore = i;
                        }
                    } else {
                        lastbefore = i;
                    }
                }
                if (!tma.itemType) {
                    tma.itemType = 'tma';
                    timeline.splice(lastbefore + 1, 0, tma);
                }
            }

            return timeline;
        },

        replaceProductAndProgramChip() {
            const productPlaceholder = document.querySelector('#product-chip');
            productPlaceholder.replaceWith(this.$refs.productChip.$el);
            const programPlaceholder = document.querySelector('#program-chip');
            programPlaceholder.replaceWith(this.$refs.programChip.$el);
        }
    },

    created() {
        this.$nextTick(() => {
            this.displayPercents = true;
            this.replaceProductAndProgramChip();
        });
    }
};
</script>
